import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '../utils/api';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken');
      const userStr = localStorage.getItem('adminUser');

      // Check if token exists
      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Admin, super admin and manager may all use the dashboard. What each
      // can actually do is enforced by the API, not here.
      const STAFF_ROLES = ['admin', 'super_admin', 'manager'];

      try {
        const user = JSON.parse(userStr);
        const roles = Array.isArray(user.roles) && user.roles.length
          ? user.roles
          : [user.role];

        if (!roles.some((r) => STAFF_ROLES.includes(r))) {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminUser');
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
      } catch (error) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Validate token by making a test API call
      try {
        // Make a lightweight API call to validate token
        const res = await api.get('/auth/profile');

        // Refresh the cached user. Without this, a role change only takes
        // effect after the person happens to log out.
        const fresh = res?.data?.data?.user || res?.data?.data || null;
        if (fresh && fresh.role) {
          localStorage.setItem('adminUser', JSON.stringify(fresh));
        }

        setIsAuthenticated(true);
      } catch (error) {
        // Token is invalid or expired, interceptor will handle cleanup
        console.log('Token validation failed, redirecting to login');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
